import { Navigate } from 'react-router-dom';

import { useAuth } from '../contexts/auth-context';

/**
 * Protege o painel de administração da plataforma.
 *
 * É uma barreira de INTERFACE: evita mostrar uma tela que a API recusaria de
 * qualquer jeito. A autorização real mora no servidor (ADMIN_EMAILS +
 * require-admin), então adulterar o estado do app aqui não abre nada.
 *
 * Quem está logado mas não é admin vai para a própria dashboard, e não para o
 * login: mandar um usuário legítimo à tela de login sugeriria que a sessão
 * dele caiu, o que seria mentira.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <p className="page-loading">Carregando…</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
